import React from "react";

import styles from "./Actions.module.css";
import { beverageActionTypes, timesMap } from "../BeverageConstants";
import { camelCaseToHumanReadable } from "../../../utils/camelCaseToHumanReadable";
import { MAX_BEVERAGE_DESCRIPTION_LENGTH } from "../../../utils/beverageDescriptionLimit";
import { CharacterCount, InvalidCharactersError } from "~/components";
import { hasDisallowedCharacters } from "../../../utils/beverageTextValidation";

export const Actions = (props) => {
  const { next, action, isAnsweringConsent } = props;
  const [text, setText] = React.useState("");
  const [saveToProfile, setSaveToProfile] = React.useState(true);
  const [optPersonalization, setOptPersonalization] = React.useState(true);

  switch (action?.type) {
    case beverageActionTypes.Start:
      return (
        <div className={styles.buttonWrapper}>
          <button
            data-testid="beverage-chat-submit"
            onClick={() => next()}
            className={`${styles.button} custom_click_track`}
            data-custom_click_track_value="Beverage V4|Start: Let's Do It|internal"
          >
            Let’s do it!
          </button>
        </div>
      );
    case beverageActionTypes.Text:
    case beverageActionTypes.TextDisabled: {
      const disabled = action.type === beverageActionTypes.TextDisabled;
      return (
        <div className={styles.textWrapper}>
          <div className={styles.textInputWrapper}>
            <input
              data-testid="beverage-description"
              disabled={disabled}
              placeholder={
                action.type === beverageActionTypes.Text
                  ? "Coffee in the morning.."
                  : ""
              }
              type="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              maxLength={MAX_BEVERAGE_DESCRIPTION_LENGTH}
            ></input>
            <CharacterCount
              value={text}
              max={MAX_BEVERAGE_DESCRIPTION_LENGTH}
            />
            <InvalidCharactersError value={text} />
          </div>
          <button
            data-testid="beverage-chat-submit"
            aria-label="Send"
            disabled={disabled || hasDisallowedCharacters(text)}
            className="custom_click_track"
            data-custom_click_track_value="Beverage V4|Text: Send|internal"
            onClick={() => {
              next(text);
              setText("");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M8.74964 11.25L17.4996 2.50002M8.85596 11.5234L11.0461 17.1551C11.239 17.6512 11.3355 17.8993 11.4745 17.9717C11.595 18.0345 11.7385 18.0345 11.8591 17.9719C11.9982 17.8997 12.0949 17.6517 12.2884 17.1558L17.7804 3.08269C17.9551 2.63504 18.0424 2.41121 17.9946 2.26819C17.9532 2.14398 17.8557 2.04651 17.7315 2.00501C17.5885 1.95723 17.3646 2.04458 16.917 2.21927L2.84386 7.71122C2.34796 7.90474 2.10001 8.0015 2.02775 8.14059C1.96512 8.26116 1.9652 8.4047 2.02798 8.5252C2.1004 8.66421 2.34846 8.76067 2.84458 8.95361L8.47625 11.1437C8.57696 11.1829 8.62731 11.2024 8.66972 11.2327C8.7073 11.2595 8.74016 11.2924 8.76697 11.3299C8.79721 11.3723 8.8168 11.4227 8.85596 11.5234Z"
                stroke="white"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      );
    }
    case beverageActionTypes.Time: {
      const { itemsToSpecify } = action;
      const isSubmitDisabled = itemsToSpecify.some(({ time }) => !time);
      return (
        <div className={styles.timeWrapper}>
          <ul className={styles.itemsToSpecifyTime}>
            {itemsToSpecify.map(({ item, time }, i) => {
              const timeArr = (time ?? "").split(", ");
              return (
                <li key={i}>
                  {camelCaseToHumanReadable(item)}
                  <ul className={styles.checkboxes} data-testid="beverage-chat-options">
                    {Object.entries(timesMap).map(([value, label], j) => (
                      <li key={j}>
                        <label className={styles.checkboxWrapper}>
                          <input
                            data-testid="beverage-chat-option"
                            type="checkbox"
                            className="custom_click_track"
                            data-custom_click_track_value={`Beverage V4|Time: ${camelCaseToHumanReadable(item)} - ${label}|internal`}
                            onChange={() => next(value, item)}
                            checked={timeArr.includes(value)}
                          />
                          {label}
                        </label>
                      </li>
                    ))}
                  </ul>
                </li>
              );
            })}
          </ul>

          <button
            data-testid="beverage-chat-submit"
            disabled={isSubmitDisabled}
            onClick={() => next()}
            className={`${styles.button} custom_click_track`}
            data-custom_click_track_value="Beverage V4|Time: Send|internal"
          >
            Send
          </button>
        </div>
      );
    }
    case beverageActionTypes.SaveProfile: {
      return (
        <div className={styles.timeWrapper}>
          <ul className={styles.checkboxes} data-testid="beverage-chat-options">
            <li>
              <label className={styles.checkboxWrapper}>
                <input
                  data-testid="beverage-chat-option"
                  type="checkbox"
                  className="custom_click_track"
                  data-custom_click_track_value="Beverage V4|SaveProfile: Yes Please|internal"
                  onChange={() => setSaveToProfile(true)}
                  checked={saveToProfile}
                />
                Yes, please! Save my favorite sip to my profile 😃
              </label>
            </li>
            <li>
              <label className={styles.checkboxWrapper}>
                <input
                  data-testid="beverage-chat-option"
                  type="checkbox"
                  className="custom_click_track"
                  data-custom_click_track_value="Beverage V4|SaveProfile: No Thank You|internal"
                  onChange={() => setSaveToProfile(false)}
                  checked={!saveToProfile}
                />
                No thank you, I don’t want special treatment
              </label>
            </li>
          </ul>
          <button
            data-testid="beverage-chat-submit"
            onClick={() =>
              saveToProfile
                ? next()
                : (window.location.href = "https://www.marriott.com/default.mi")
            }
            className={`${styles.button} custom_click_track`}
            data-custom_click_track_value={`Beverage V4|SaveProfile: Send|${saveToProfile ? "internal" : "external"}`}
          >
            Send
          </button>
        </div>
      );
    }
    case beverageActionTypes.Login: {
      return (
        <div className={styles.buttonWrapper}>
          <button
            data-testid="beverage-chat-submit"
            onClick={() => next()}
            className={`${styles.button} custom_click_track`}
            data-custom_click_track_value="Beverage V4|Login: Log Me In|internal"
          >
            Log me in!
          </button>
        </div>
      );
    }
    case beverageActionTypes.OnsitePersonalization: {
      return (
        <div className={styles.timeWrapper}>
          <ul className={styles.checkboxes} data-testid="beverage-chat-options">
            <li>
              <label className={styles.checkboxWrapper}>
                <input
                  data-testid="beverage-chat-option"
                  type="checkbox"
                  className="custom_click_track"
                  data-custom_click_track_value="Beverage V4|OnsitePersonalization: Definitely|internal"
                  onChange={() => setOptPersonalization(true)}
                  checked={optPersonalization}
                />
                Definitely, thanks for asking.
              </label>
            </li>
            <li>
              <label className={styles.checkboxWrapper}>
                <input
                  data-testid="beverage-chat-option"
                  type="checkbox"
                  className="custom_click_track"
                  data-custom_click_track_value="Beverage V4|OnsitePersonalization: No Thank You|internal"
                  onChange={() => setOptPersonalization(false)}
                  checked={!optPersonalization}
                />
                No, thank you.
              </label>
            </li>
          </ul>
          <button
            data-testid="beverage-chat-submit"
            onClick={() => next(optPersonalization)}
            disabled={isAnsweringConsent}
            className={`${styles.button} custom_click_track`}
            data-custom_click_track_value="Beverage V4|OnsitePersonalization: Send|internal"
          >
            {isAnsweringConsent ? "Saving..." : "Send"}
          </button>
        </div>
      );
    }
    case beverageActionTypes.ThankYou: {
      return (
        <div className={styles.buttonWrapper}>
          <button
            data-testid="beverage-chat-submit"
            onClick={() => next()}
            className={`${styles.button} custom_click_track`}
            data-custom_click_track_value="Beverage V4|ThankYou: Got It|internal"
          >
            Got it 👍 thanks!
          </button>
        </div>
      );
    }
    case beverageActionTypes.Repeat: {
      return (
        <div className={styles.buttonsWrapper}>
          <button
            data-testid="beverage-chat-decline"
            onClick={() =>
              (window.location.href = "https://www.marriott.com/default.mi")
            }
            className={`${styles.cancelButton} custom_click_track`}
            data-custom_click_track_value="Beverage V4|Repeat: No Thanks|external"
          >
            No Thanks
          </button>
          <button
            data-testid="beverage-chat-restart"
            onClick={() => next()}
            className={`${styles.button} custom_click_track`}
            data-custom_click_track_value="Beverage V4|Repeat: Sure|internal"
          >
            Sure
          </button>
        </div>
      );
    }
    default:
      return null;
  }
};
